import { render, staticRenderFns } from "./doctorList.vue?vue&type=template&id=b3884bd8&scoped=true&"
import script from "./doctorList.vue?vue&type=script&lang=js&"
export * from "./doctorList.vue?vue&type=script&lang=js&"
import style0 from "./doctorList.vue?vue&type=style&index=0&id=b3884bd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3884bd8",
  null
  
)

export default component.exports